angular.module('examgen.directive').
directive('helpIframe', function() {
  return function(scope, el) {
    scope.$watch('showHelp', function(a) {
      if (a === true) {
        el.attr('src', 'http://www.examgenonline.com/Help');
      }
    });
  };
});